
import { Component, Vue } from "vue-property-decorator";
import LayoutBase from "./components/layout/layout-base.vue";

@Component({
  components: {
    LayoutBase
  }
})
export default class App extends Vue {}
